// Canal comercial (Comercial / Parceiros) — não é uma coluna no banco, é derivado do
// papel/departamento do responsável. Extraído de PerformanceDashboard.tsx para ser
// compartilhado com AnalyticsComercialView.tsx sem duplicar a lógica.
//
// Até 29/10/2026 eram três canais (Venda Externa, Venda Interna, Parceiros). O Comercial
// virou um departamento só (#6520): Closer, BDR e Hunter são funções dentro dele, e as
// telas mostram a função ao lado da pessoa. Parcerias continua separado, mas entra na
// meta do Comercial.
import type { Profile } from '../../types';

export const CHANNELS = ['Comercial', 'Parceiros'] as const;
export type Canal = 'Todos' | typeof CHANNELS[number];

export const getChannel = (p: Profile | undefined): string => {
    if (!p) return 'Comercial';
    if (p.role === 'parceiro' || p.role === 'vendedor_parceiro' || p.role === 'gerente_parcerias' || p.departamento === 'Parcerias') return 'Parceiros';
    return 'Comercial';
};

// Oculta contas de teste/genéricas de rankings, metas e totais.
export const isTestAccount = (p: Profile | undefined): boolean => {
    if (!p) return true;
    const name = (p.full_name || '').trim().toLowerCase();
    if (/teste|test\b|user test/.test(name)) return true;
    return ['executivo comercial', 'vendedor parceiro'].includes(name);
};
